import { ClipLoader } from 'react-spinners'
import styled from 'styled-components'

const Loading = () => {
  return (
    <LoadingWrap>
      <ClipLoader color="#55bc7e" aria-label="loading spinner" />
    </LoadingWrap>
  )
}

export default Loading

const LoadingWrap = styled.div`
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--white);
  opacity: 0.6;
  z-index: 9999;
`
